module.exports = __webpack_public_path__ + "static/frog1-e1a1cc30513f6fdf29134a42c83fdc03.png";